package org.gstechnovos.jexonplastech.sections.contact.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px

val ContactHeaderContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.brand.primaryBlue)
    }
}